import Article1 from "../images/article1.jpg";
import Article2 from "../images/article2.jpg";
import Article3 from "../images/article3.jpg";
import Article4 from "../images/article4.jpg";
import Article5 from "../images/article5.jpg";
import Article6 from "../images/article6.jpg";
import Article7 from "../images/article7.jpg";

export const articledata = {
    "0" : {
        article_source: Article1,
        article_title: "The Aim of the Edit",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19210117-01.2.14&srpos=141&e=-------en-20-cs-141--txt-txIN-editorial------ ",
        article_date: "January 17, 1921"
    },
    "1" : {
        article_source: Article2,
        article_title: "News in White and White",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20040326-01.2.23&srpos=2&e=-------en-20-cs-1--txt-txIN-%22opinion+staff%22----2004--#documentdisplayleftpanesectionleveltabcontent",
        article_date: "March 26, 2004"
    },
    "2" : {
        article_source: Article3,
        article_title: "Letter to the Editor: Opinion Editors Must Preserve Their Independence",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20041015-01.2.18&srpos=6&e=-------en-20-cs-1--txt-txIN-editorial+staff+mission------",
        article_date: "October 11, 2004"
    },
    "3" : {
        article_source: Article4,
        article_title: "This Is How We Do It",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20080218-01.2.28&srpos=106&e=-------en-20-cs-101--txt-txIN-editorial------",
        article_date: "February 18, 2008"
    },
    "4" : {
        article_source: Article5,
        article_title: "Discourses discord",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20100301-01.2.21&srpos=5&e=------201-en-20--1--txt-txIN-Purpose+of+the+Editorial+Page------",
        article_date: "March 1, 2010"
    },
    "5" : {
        article_source: Article6,
        article_title: "How to write an opinion column",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20100419-01.2.23&srpos=1&e=------201-en-20--1--txt-txIN-How+to+write+an+opinion+column------",
        article_date: "April 19, 2010"
    },
    "6" : {
        article_source: Article7,
        article_title: "Being a good editor, on and off the page",
        article_link: "https://www.columbiaspectator.com/opinion/2019/05/20/being-a-good-editor-on-and-off-the-page/",
        article_date: "May 20, 2019"
    },
    "7" : {
        article_source: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/VU6YBEBKX5CH3NMX4JLMBMBOJY.jpeg",
        article_title: "Letter from the Editor: Why we published op-eds arguing against the mask mandate on campus,",
        article_link: "https://www.columbiaspectator.com/opinion/2022/02/28/letter-from-the-editor-why-we-published-op-eds-arguing-against-the-mask-mandate-on-campus/",
        article_date: "February 28, 2022"
    },
    "8" : {
        article_source: "https://www.columbiaspectator.com/resizer/v2/EDXUGLJGJBHDNJJJ2FRUG644LE.jpeg?auth=6718354a3d0e0266bcb13daa432e0999a713d866f3f661117ee83c0fff72d113",
        article_title: "Letter from the Editor: We need your voices now more than ever,",
        article_link: "https://www.columbiaspectator.com/resizer/v2/EDXUGLJGJBHDNJJJ2FRUG644LE.jpeg?auth=6718354a3d0e0266bcb13daa432e0999a713d866f3f661117ee83c0fff72d113",
        article_date: "October 18, 2023"
    },
    "9" : {
        article_source: "https://www.columbiaspectator.com/resizer/v2/FEMZ4NNEP5HZNPHN5HKACQL7W4.jpg?auth=6f7c541e76334486e5d606708f605e44caedacd886b316b38e7306620e3e06fb",
        article_title: "Letter from the Editor: What we owe each other",
        article_link: "https://www.columbiaspectator.com/opinion/2024/08/25/letter-from-the-editor-what-we-owe-each-other/",
        article_date: "August 24, 2024"
    },
    "10" : {
        article_source: "https://www.columbiaspectator.com/resizer/v2/TTWQHRUPNJGOXHFWCTTXABDJPU.jpeg?auth=be5529533711742cf4ec0ee0f7cb834ef45087d2c44306b208c3b34bc4577afd",
        article_title: "The purpose of Opinion",
        article_link: "https://www.columbiaspectator.com/opinion/2025/03/23/the-purpose-of-opinion/ ",
        article_date: "March 23, 2025"
    },
    "11" : {
        article_source: "https://www.columbiaspectator.com/resizer/v2/62XSCYI4SVETXNP7ZBTRF25OOY.png?auth=98847183246af9687be511c4aaaaa9e32e8aae73ec853c4edb0aabd34ff353b4",
        article_title: "Letter from the Editor: With the media in crisis, the editorial page matters more than ever",
        article_link: "https://www.columbiaspectator.com/opinion/2025/09/23/letter-from-the-editor-with-the-media-in-crisis-the-editorial-page-matters-more-than-ever/",
        article_date: "September 23, 2025"
    }
    
}